/* eslint-disable no-template-curly-in-string */
/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
	Row,
	Col,
	Card,
	Form,
	Input,
	DatePicker,
	Select,
	Button,
	AutoComplete,
	Modal,
	Spin,
} from 'antd';
import {
	PrinterOutlined,
	SyncOutlined,
	SnippetsOutlined,
	RollbackOutlined,
	SaveOutlined,
	StopOutlined,
	ExclamationCircleOutlined,
} from '@ant-design/icons';
import PageTitle from 'shared_components/page_title';
import { AlphaNumInput } from 'shared_components/pattern_input';
import moment from 'moment';
import './invoice_data_entry.css';
import InvoiceTable from './invoiceTable.jsx';
import { numberFormat, formatTIN } from 'utils/helper';
import Message from 'shared_components/message';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
//lov api
import {
	fetchAgentsListAPI,
	fetchCustomersListAPI,
	fetchVatListAPI,
	fetchTermsListAPI,
	fetchMessageListAPI,
	fetchBillAddListAPI,
	fetchUnitsListAPI,
	fetchInvTypesListAPI,
} from 'services/shared/fetchLovList';
//invoice api
import {
	fetchCustomerDetailsAPI,
	fetchInvoiceDetailsAPI,
	fetchDrListAPI,
	fetchInvoiceHeaderAPI,
	createInvoiceAPI,
	updateInvoiceAPI,
	deleteInvDetailsAPI,
	searchInvoiceAPI,
	printInvoice,
	invPrintedTrxnAPI,
	fetchSelectedDrAPI,
	printInvoicePreview,
	// invPrintexTrxnList
} from 'services/invoice/invoice';
import { UserAccessContext } from 'context/userAccess';
import { fetchUsersName } from 'services/users/users';
import { invoiceSearchLink } from 'global_config/uri';
import { Radio } from 'antd';

const { Option } = Select;
const footerStyleRight = { textAlign: 'right' };
const formItemStyle = { paddingBlock: 0, marginBlock: 4, borderBlock: 0 };

function getApiErrorMessage(error, fallbackMessage = 'Something went wrong.') {
	const responseData = error && error.response ? error.response.data : null;

	if (typeof responseData === 'string' && responseData.trim() !== '') {
		return responseData;
	}

	if (responseData && typeof responseData.message === 'string' && responseData.message.trim() !== '') {
		return responseData.message;
	}

	if (error && typeof error.message === 'string' && error.message.trim() !== '') {
		return error.message;
	}

	return fallbackMessage;
}

export default function DataEntry(props) {
	const invDetProps = props.invoiceDetails === 'undefined' ? '' : props.invoiceDetails;
	console.log('🚀 ~ DataEntry ~ invDetProps:', invDetProps);
	const { userAccess, printedInvList } = useContext(UserAccessContext);

	const navigate = useHistory();
	const [form] = Form.useForm();
	const [isloading, setLoading] = useState(true);
	const [tblLoading, setTblLoading] = useState(false);

	const [invDetails, setInvDetails] = useState([]);
	console.log("🚀 ~ invDetails:", invDetails)
	const [detailsData, setDetailsData] = useState([]);
	const [deleteList, setDeleteList] = useState([]);
	const [drDeleteList, setDrDeleteList] = useState([]);

	const [allDisabled, setAllDisabled] = useState(false);
	const [editButtonDisabled, setEditButtonDisabled] = useState(false);
	const [printPrintButtonDisabled, setPrintButtonDisabled] = useState();
	const [printLoading, setPrintLoading] = useState(false);
	const [printPreviewLoading, setPrintPreviewLoading] = useState(false);
	const [editButtonClicked, setEditButtonClicked] = useState(false);
	const [soldToDisabled, setSoldToDisabled] = useState(true);
	const [checkPost, setCheckPost] = useState(true);
	const [invoiceTotAmt, setInvoiceTotAmt] = useState(0);
	const [vatAmt, setVatAmt] = useState(0);
	const [billingAddList, setBillingAddList] = useState([]);
	const [filterDrNoList, setFilterDrNoList] = useState([]);
	// const [selectedDrList, setSelectedDrList] = useState([]);

	const [previousSoldToValue, setPreviousSoldToValue] = useState(null);
	const [soldChanged, setSoldChanged] = useState(false);

	const [usersList, setUsersList] = useState([]);
	const [agentsList, setAgentsList] = useState([]);
	const [customersList, setCustomersList] = useState([]);
	const [customerDetList, setCustomerDetList] = useState([]);
	const [vatList, setVatList] = useState([]);
	const [termsList, setTermsList] = useState([]);
	const [drNoList, setDrNoList] = useState([]);
	const [selectedDrIdList, setSelectedDrIdList] = useState([]);
	const [billAddList, setBillAddList] = useState([]);
	const [unitList, setUnitList] = useState();
	const [messagesList, setMessagesList] = useState([]);
	const [invTypesList, setInvTypesList] = useState([]);
	// const [selectedDrDetails, setSelectedDrDetails] = useState([]);

	//additional for terms
	const [termsValue, setTermsValue] = useState(props.isEditing ? invDetProps.term_name : '');
	const [cashChargeValue, setCashChargeValue] = useState(
		termsValue === 'CASH' ? 'CASH SALES' : 'CHARGE SALES',
	);

	const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

	const cancelInvoiceRight = userAccess['invoices'].cancel;
	const postInvoiceRight = userAccess['invoices'].post;
	const printInvoiceRight = userAccess['invoices'].print;
	const updateInvoiceRight = userAccess['invoices'].update;
	const overrideInvoiceRight = userAccess['invoices'].override;

	// get LOV values
	async function getLOVList() {
		try {
			const users = await fetchUsersName();
			const agents = await fetchAgentsListAPI();
			const customers = await fetchCustomersListAPI();
			const customerDet = await fetchCustomerDetailsAPI();
			const vatInput = await fetchVatListAPI();
			const terms = await fetchTermsListAPI();
			const drNo = await fetchDrListAPI();
			const units = await fetchUnitsListAPI();
			const billAddDet = await fetchBillAddListAPI();
			const invTypes = await fetchInvTypesListAPI();
			const messages = await fetchMessageListAPI();
			// const printedTrxnList = await invPrintexTrxnList();

			if (props.isEditting) {
				const selectedDr = await fetchSelectedDrAPI(invDetProps.dr_val);
				// setSelectedDrList(selectedDr)
				const filterDrNo = drNo.filter(items => items.customer_id === invDetProps.customer_id);

				const mergeDrNo = [...filterDrNo, ...selectedDr];
				setFilterDrNoList(mergeDrNo);

				const filterBillingAdd = billAddDet.filter(
					items => items.customer_id === invDetProps.customer_id,
				);
				setBillingAddList(filterBillingAdd);

				setCashChargeValue(invDetProps.term_name === 'CASH' ? 'CASH SALES' : 'CHARGE SALES');
			}

			setUsersList(users);
			setBillAddList(billAddDet);
			setAgentsList(agents);
			setCustomersList(customers);
			setCustomerDetList(customerDet);
			setVatList(vatInput);
			setTermsList(terms);
			setDrNoList(drNo);
			setUnitList(units);
			setInvTypesList(invTypes);
			setMessagesList(messages);
			// setPrintedInvList(printedTrxnList);

			//test loader spin
			if (messages) {
				setLoading(false);
			}
		} catch (error) {
			console.log('getLOVList error', error);
		}
	}

	// set LOV values
	useEffect(() => {
		const fetchData = () => {
			getLOVList();
		};
		fetchData();
	}, []);

	useEffect(() => {
		setCheckPost(checkPost);
	}, [checkPost]);

	// Sync the form value with the state on mount and whenever termsValue changes
	useEffect(() => {
		form.setFieldsValue({ cash_charge: cashChargeValue });
	}, [cashChargeValue, form]);

	//billing address list based on customer
	const addressOptions = billingAddList
		.sort((a, b) => a.billing_address.localeCompare(b.billing_address))
		.map((item, index) => {
			return (
				<Option key={index} value={item.billing_address}>
					{item.billing_address.toUpperCase()}
				</Option>
			);
		});

	//get agents list
	const agentOptions = agentsList.map((item, index) => {
		return (
			<Option key={item.agent_id} value={item.agent_id}>
				{item.agent}
			</Option>
		);
	});

	//get customers list used in sold to input field
	const soldToOptions = customersList.map((item, index) => {
		return (
			<Option key={item.customer_id} value={item.customer_val}>
				{item.customer}
			</Option>
		);
	});

	//get vat input list
	const vatInputOptions = vatList.map((item, index) => {
		return (
			<Option key={index} value={item.vat_input_name}>
				{item.vat_input_name}
			</Option>
		);
	});

	//get terms list
	const termsOptions = termsList.map((item, index) => {
		return (
			<Option key={item.term_id} value={item.term_name}>
				{item.term_name}
			</Option>
		);
	});

	//business style list based on customer
	const busStyleOptions = billingAddList
		.sort((a, b) => (a.business_style > b.business_style ? 1 : -1))
		.map((item, index) => {
			return (
				<Option key={index} value={item.business_style}>
					{item.business_style.toUpperCase()}
				</Option>
			);
		});

	//get invoice types list
	const invTypesOptions = invTypesList.map((item, index) => {
		return (
			<Option key={item.invoice_type_id} value={item.invoice_type_name}>
				{item.invoice_type_name}
			</Option>
		);
	});

	async function getInvoiceDetails() {
		const invID = invDetProps.invoice_id;

		try {
			const getInvDet = await fetchInvoiceDetailsAPI(invID);
			setInvDetails(getInvDet);

			if (props.isEditting) {
				if (!invDetails) {
					setTblLoading(true);
				} else {
					setTblLoading(false);
				}
			}
		} catch (error) {
			console.log('getInvoiceDetails error', error);
		}
	}

	// invoice details and update
	useEffect(() => {
		if (props.isEditting) {
			console.log('check printed');

			if (
				invDetProps.status_name === 'POSTED' ||
				invDetProps.status_name === 'CANCELLED' ||
				updateInvoiceRight === 'FALSE'
			) {
				setSoldToDisabled(true);
				setAllDisabled(true);
			} else {
				setSoldToDisabled(false);
			}

			const printedInv = printedInvList.find(
				inv => inv.trxn_type === 'invoice' && inv.trxn_no === invDetProps.invoice_no,
			);

			if (printedInv) {
				console.log('check printed trxn');
				// setAllDisabled(true);
				// setSoldToDisabled(true);
				setEditButtonDisabled(true);
				setPrintButtonDisabled(false);
			}
			getInvoiceDetails();
		}

		// Initialize selectedDrIdList with saved DR values when editing
		const initialSelectedDrIdList = props.isEditting
			? invDetProps.dr_val === null
				? []
				: invDetProps.dr_val.split(',').map(n => parseInt(n, 10))
			: [];

		console.log('🚀 ~ initializing selectedDrIdList:', initialSelectedDrIdList);
		setSelectedDrIdList(initialSelectedDrIdList);
	}, [props, invDetProps]);



	// Reset drDeleteList after successful save
	useEffect(() => {
		if (props.isEditting && invDetProps) {
			// After save, the drDeleteList should be cleared as those deletions were processed
			setDrDeleteList([]);
		}
	}, [props.isEditting, invDetProps]);

	const calculateWithholdingAndTotalDue = () => {
        const { ewtamt, netOfVat = '', invoiceAmount = '' } = form.getFieldsValue();
      
        // Parse the input values as numbers
        const ewt = parseFloat(ewtamt);
        const netOfVatValue = parseFloat(netOfVat.replace(/,/g, '')) || 0;
        const invoiceAmountNew = parseFloat(invoiceAmount.replace(/,/g, '')) || 0;
      
        // Always calculate withholding tax based on form inputs
        let withHoldTax =
          isNaN(ewt) || isNaN(netOfVatValue)
            ? 0
            : netOfVatValue === 0
            ? invoiceAmountNew * ewt
            : netOfVatValue * ewt;
      
        // Use external value only if editing is allowed and invDetProps exists
        if (props.isEditing && invDetProps && invDetProps.withholdtax) {
          withHoldTax = invDetProps.withholdtax;
        }
      
        // Calculate total amount due
        const totAmtDue =
          isNaN(invoiceAmountNew) || isNaN(withHoldTax) ? 0 : invoiceAmountNew - withHoldTax;
      
        return { withHoldTax, totAmtDue };
      };
      
      const ewtOnchange = async () => {
        const { withHoldTax, totAmtDue } = calculateWithholdingAndTotalDue(); // Use shared calculation
      
        // Update the form with the calculated values
        await form.setFieldsValue({
          withholdTax: numberFormat(withHoldTax, 2),
          totalAmountDue: numberFormat(totAmtDue, 2),
        });
      };
      

	//check vat input
	const checkVatInput = value => {
		let vatInclusive, vatIncAmt, vatExclusive;

		switch (value) {
			case 'VAT INCLUSIVE':
				vatInclusive = invoiceTotAmt / 1.12;
				vatIncAmt = invoiceTotAmt - vatInclusive;

				form.setFieldsValue({
					vatableSales: numberFormat(vatInclusive, 2),
					invoiceAmount: numberFormat(invoiceTotAmt, 2),
					vatAmount: numberFormat(vatIncAmt, 2),
					lessVat: numberFormat(vatIncAmt, 2),
					netOfVat: numberFormat(vatInclusive, 2),
					addVat: numberFormat(vatIncAmt, 2),
					zeroRateSales: numberFormat(0, 2),
				});
				break;

			case 'VAT EXCLUSIVE':
				vatExclusive = invoiceTotAmt + vatAmt;

				form.setFieldsValue({
					vatableSales: numberFormat(invoiceTotAmt, 2),
					invoiceAmount: numberFormat(vatExclusive, 2),
					vatAmount: numberFormat(vatAmt, 2),
					lessVat: numberFormat(vatAmt, 2),
					netOfVat: numberFormat(invoiceTotAmt, 2),
					addVat: numberFormat(vatAmt, 2),
					zeroRateSales: numberFormat(0, 2),
				});
				break;

			default:
				form.setFieldsValue({
					vatableSales: numberFormat(0, 2),
					invoiceAmount: numberFormat(invoiceTotAmt, 2),
					vatAmount: numberFormat(0, 2),
					zeroRateSales: numberFormat(invoiceTotAmt, 2),
					netOfVat: numberFormat(0, 2),
					withholdTax: numberFormat(0, 2),
					totalAmountDue: numberFormat(invoiceTotAmt, 2),
					lessVat: numberFormat(0, 2),
					addVat: numberFormat(0, 2),
				});
				break;
		}

		// Calculate withholding tax and total amount due after setting values
		const { withHoldTax, totAmtDue } = calculateWithholdingAndTotalDue();
		form.setFieldsValue({
			withholdTax: numberFormat(withHoldTax, 2),
			totalAmountDue: numberFormat(totAmtDue, 2),
		});
	};

	const handleTermsChange = value => {
		setTermsValue(value);
		const newCashChargeValue = value === 'CASH' ? 'CASH SALES' : 'CHARGE SALES';
		setCashChargeValue(newCashChargeValue);

		// Directly update form field value as well to ensure the UI is in sync
		form.setFieldsValue({ cash_charge: newCashChargeValue });
	};

	//invoice total amount
	const handleTotVal = payload => {
		const getTotInvoice = payload;
		setInvoiceTotAmt(getTotInvoice);

		const getVatAmt = parseFloat(getTotInvoice * 0.12);
		setVatAmt(getVatAmt);

		const checkVatInputValue = form.getFieldsValue().vatInput;
		checkVatInput(checkVatInputValue);
	};

	// handle onchange input of tin
	// const tinValue = (e) => {
	//     const formattedTIN = formatTIN(e.target.value);
	//     form.setFieldsValue({taxNumber: formattedTIN});
	// };

	// Handle onchange input of TIN with 20 character limit
	const tinValue = e => {
		let input = e.target.value;

		// Limit input to 20 characters
		if (input.length > 20) {
			input = input.slice(0, 20); // Truncate input if it exceeds the limit
		}

		form.setFieldsValue({ taxNumber: input });
	};

	const handleDrList = payload => {
		form.setFieldsValue({ drNumber: payload });

		// IMPROVED: Only add to delete list if we're editing an existing invoice
		if (props.isEditting && selectedDrIdList.length > 0) {
			const difference = selectedDrIdList.filter(x => !payload.includes(x));
			if (difference.length > 0) {
				const drDelList = [...drDeleteList, ...difference];
				console.log("🚀 ~ handleDrList ~ Adding to drDeleteList:", difference);
				console.log("🚀 ~ handleDrList ~ Updated drDeleteList will be:", drDelList);
				setDrDeleteList(Array.from(new Set(drDelList))); // Ensure uniqueness
			}
		}

		// Update the selected DR list
		setSelectedDrIdList(payload);
	};

	const clearDRList = () => {
		setSelectedDrIdList([]);
	}

	//handle Sold To
	const handleSoldToOnChange = async value => {
		// Save the current "Sold To" value before making any changes
		if (!previousSoldToValue) {
			setPreviousSoldToValue(form.getFieldValue('soldTo')); // Save the current Sold To value before any change
			setFilterDrNoList([]); //clear dr list
		}
		
		const resetFormFields = () => {
			// Clear DR-related data first
			setSelectedDrIdList([]);
			setInvDetails([]);
			
			// Clear table data to notify child components
			handleTableData([]);
			
			// Clear form fields
			form.setFieldsValue({
				drNumber: [], 
			});
			form.resetFields(['drNumber']); // Reset the drNumber field
			
			// Clear any cached invoice data
			if (props.isEditting && invDetProps && invDetProps.invoice_id) {
				sessionStorage.removeItem(`invoice_${invDetProps.invoice_id}_had_drs`);
			}
			
			if (!props.isEditting) {
				setSoldToDisabled(false);
			}
		};

		const updateFormFields = (custDet, billAddDet) => {
			let bussStyle = '';
			let billAdd = '';
			let taxIDNo = '';
			let agentVal = '';

			if (billAddDet && billAddDet.length > 0) {
				bussStyle = billAddDet[0].business_style !== undefined ? billAddDet[0].business_style : '';
				billAdd = billAddDet[0].billing_address !== undefined ? billAddDet[0].billing_address : '';
				taxIDNo = billAddDet[0].tax_id_no !== undefined ? billAddDet[0].tax_id_no : '';
			}

			if (
				custDet &&
				custDet.length > 0 &&
				custDet[0].agent_id !== null &&
				custDet[0].agent_id !== undefined
			) {
				agentVal = Number(custDet[0].agent_id);
			}

			form.setFieldsValue({
				vatInput: custDet && custDet.length > 0 && custDet[0].vat_input_name !== null ? custDet[0].vat_input_name : '',
				terms: custDet && custDet.length > 0 && custDet[0].term_name !== null ? custDet[0].term_name : '',
				agent: agentVal,
				businessStyle: bussStyle,
				address: billAdd,
				taxNumber: taxIDNo,
				drNumber: [],
				ewtamt:
					custDet && custDet.length > 0 && custDet[0].ewt_rate !== null
						? String(custDet[0].ewt_rate)
						: null,
				cash_charge:
					custDet && custDet.length > 0 && custDet[0].term_name === 'CASH'
						? 'CASH SALES'
						: 'CHARGE SALES',
			});

			ewtOnchange();

			if (custDet && custDet.length > 0 && custDet[0].vat_input_name !== undefined) {
				checkVatInput(custDet[0].vat_input_name);
			}
		};

		const handleCustomerChange = () => {
			try {
				const filterCustomer = customersList.filter(item => item.customer_val === value);
				const customerId = filterCustomer.length > 0 ? filterCustomer[0].customer_id : null;

				if (customerId) {
					const filterDrNo = drNoList.filter(item => item.customer_id === customerId);
					setFilterDrNoList(filterDrNo);

					const custDet = customerDetList.filter(item => item.customer_id === customerId);
					const billAddDet = billAddList.filter(item => item.customer_id === customerId);

					setBillingAddList(billAddDet.length > 0 ? billAddDet : []);
					updateFormFields(custDet, billAddDet);
					setSoldChanged(true);
				}
			} catch (error) {
				console.log('handleSoldToOnChange error', error);
			}
		};

		// Log the initial value of the "Sold To" field
		console.log('Current Sold To value:', form.getFieldValue());

		if (detailsData.length > 0) {
			Modal.confirm({
				title: 'Confirm Action',
				icon: <ExclamationCircleOutlined />,
				content: 'Are you sure you want to change customer?',
				okText: 'YES',
				cancelText: 'NO',
				onOk: () => {
					resetFormFields();
					handleCustomerChange();
					setPreviousSoldToValue(value); // Set the new value as the current value
				},
				onCancel: () => {
					// Restore the previous "Sold To" value if user cancels
					form.setFieldsValue({ soldTo: previousSoldToValue });
					console.log('User canceled action, restoring previous Sold To value');
				},
			});
		} else {
			resetFormFields();
			handleCustomerChange();
			setPreviousSoldToValue(value); // Set the new value as the current value
		}
	};
    

	//handle business style on select
	async function handleBSOnSelect(value) {
		const bsOnsel = billingAddList.filter(
			items => items.business_style.toUpperCase() === value.toUpperCase(),
		);

		form.setFieldsValue({
			// businessStyle: bsOnsel[0].business_style === null ? '' : bsOnsel[0].business_style,
			address: bsOnsel[0].billing_address === null ? '' : bsOnsel[0].billing_address,
			taxNumber: bsOnsel[0].tax_id_no === null ? '' : bsOnsel[0].tax_id_no,
		});
	}

	//handle billing address on select
	async function handleAddOnSelect(value) {
		const bsOnsel = billingAddList.filter(
			items => items.billing_address.toUpperCase() === value.toUpperCase(),
		);

		form.setFieldsValue({
			// address: bsOnsel[0].billing_address === null ? '' : bsOnsel[0].billing_address,
			businessStyle: bsOnsel[0].business_style === null ? '' : bsOnsel[0].business_style,
			taxNumber: bsOnsel[0].tax_id_no === null ? '' : bsOnsel[0].tax_id_no,
		});
	}

	//handle vat input
	function handleVatInputOnChange(value) {
		checkVatInput(value);
	}

	//handle table data
	function handleTableData(payload) {
		console.log("🚀 ~ handleTableData ~ payload:", payload)
		console.log("🚀 ~ handleTableData ~ selectedDrIdList before:", selectedDrIdList)
		setDetailsData(payload);
		
		// Clear DR selection when table becomes empty AND we previously had details data
		// This prevents clearing during initial load but allows clearing when user deletes all items
		if (payload.length === 0 && selectedDrIdList.length > 0 && detailsData.length > 0) {
			console.log("🚀 ~ Clearing DR selection because user deleted all table items")
			setSelectedDrIdList([]);
			form.setFieldsValue({ drNumber: [] });
		}
	}

	//handleDeleteList
	function handleDeleteList(payload) {
		setDeleteList([...deleteList, payload]);
	}
	
	const handleSelectedDrIdList = payload => {
		setSelectedDrIdList(payload);
	}

	//invoice number onBlur
	async function onBlurInvNum(payload) {
		const m0012 = messagesList.filter(items => items.message_code === 'M0012');
		const invNum = payload.target.value;
		const checkInvNum = await fetchInvoiceHeaderAPI(invNum);

		if (checkInvNum.length > 0) {
			Message.error({ message: m0012[0].message_display });
		}
	}

	// handle get updated data
	async function handPushResult() {
		const getValues = form.getFieldValue();
		const pushPayload = [{ invoice_no: getValues.invoiceNumber }];
		const invoice_no = pushPayload[0];

		try {
			// search by invoice number
			const result = await searchInvoiceAPI(invoice_no);
			return result[0];
		} catch (error) {
			return error;
		}
	}

	// Prevent Enter key from submitting the form
	// This avoids accidental form submission when pressing Enter in input fields
	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
		}
	};

	function handleSubmit(formValues) {
		const handleFormVal = [formValues];

		const selectedAgentId = Number(formValues.agent);
		const customer_val = customersList.filter(items => items.customer_val === formValues.soldTo);
		const terms_val = termsList.filter(items => items.term_name === formValues.terms);
		const inv_type_val = invTypesList.filter(
			items => items.invoice_type_name === formValues.invStatus,
		);

		const formValuesSubmit = handleFormVal.map(values => {
			return {
				...values,
				invoiceDate: moment(formValues.invoiceDate).format('YYYY/MM/DD'),
				agent_id: selectedAgentId,
				customer_id: customer_val[0].customer_id,
				terms_id: terms_val[0].term_id,
				invoice_type_id: inv_type_val[0].invoice_type_id,
				dr_delete_list: drDeleteList,
			};
		});

		const m0003 = messagesList.filter(items => items.message_code === 'M0003');
		const m0009 = messagesList.filter(items => items.message_code === 'M0009');
		const m0014 = messagesList.filter(items => items.message_code === 'M0014');

		const chLineDesc = detailsData.filter(item => item.line_description === '');
		const chLineAmt = detailsData.filter(
			item => item.line_amount === 0 || item.line_amount === '0.00',
		);

		if (formValues.submit_val === 'post' && detailsData.length === 0) {
			setCheckPost(false);
		} else if (formValues.submit_val === 'post' && detailsData.length > 0) {
			if (formValues.invoiceAmount === '0.00' || formValues.invoiceAmount === '0') {
				setCheckPost(false);
			} else if (chLineDesc.length > 0 || chLineAmt > 0) {
				setCheckPost(false);
			} else {
				setCheckPost(true);
			}
		} else if (formValues.submit_val === 'save' && detailsData.length > 0) {
			if (chLineDesc.length > 0 || chLineAmt > 0) {
				setCheckPost(false);
			} else {
				setCheckPost(true);
			}
		} else {
			setCheckPost(true);
		}

		// call modal
		if (formValues.submit_val === 'cancel') {
			Modal.confirm({
				title: m0009[0].message_title,
				icon: <ExclamationCircleOutlined />,
				content: m0009[0].message_display,
				okText: 'YES',
				cancelText: 'NO',
				onOk: () => {
					handleConfirm(formValuesSubmit[0]);
				},
			});
		} else {
			if ((chLineDesc.length > 0 || chLineAmt.length > 0) && formValues.submit_val === 'post') {
				// Message.error({ message: m0014[0].message_display });
				Message.error({ message: 'Please complete transaction details.' });
			} else {
				Modal.confirm({
					title: m0003[0].message_title,
					icon: <ExclamationCircleOutlined />,
					content: m0003[0].message_display,
					okText: 'YES',
					cancelText: 'NO',
					onOk: () => {
						handleConfirm(formValuesSubmit[0]);
					},
				});
			}
		}
	}

	async function handleConfirm(formValues) {
		const m0004 = messagesList.filter(items => items.message_code === 'M0004');
		const m0005 = messagesList.filter(items => items.message_code === 'M0005');
		const m0006 = messagesList.filter(items => items.message_code === 'M0006');
		const m0007 = messagesList.filter(items => items.message_code === 'M0007');
		const m0010 = messagesList.filter(items => items.message_code === 'M0010');
		const m0012 = messagesList.filter(items => items.message_code === 'M0012');
		const m0014 = messagesList.filter(items => items.message_code === 'M0014');

		if (checkPost) {
			if (!props.isEditting) {
				//create invoice
				try {
					const createRes = await createInvoiceAPI(formValues, detailsData);
					
					if (createRes.data.invoice_id !== undefined) {
							if (formValues.submit_val === 'post') {
								Message.success({ message: m0005[0].message_display });

								const handlePush = await handPushResult();
								navigate.push({
									pathname: '/invoice/details_update',
									state: {
										record: handlePush,
									},
								});
							} else {
								Message.success({ message: m0004[0].message_display });

								const handlePush = await handPushResult();
								navigate.push({
									pathname: '/invoice/details_update',
									state: {
										record: handlePush,
									},
								});
							}
						} else {
							const res = createRes.data;

							if (res.name === 'error' && res.code === '23505') {
								Message.error({ message: m0012[0].message_display });
							} else {
								if (res.detail !== undefined) {
									Message.error({ message: m0007[0].message_display });
								} else {
									Message.error({ message: m0007[0].message_display });
								}
							}
						}
				} catch (error) {
					console.log(error);
					const apiMessage = getApiErrorMessage(error, m0007[0].message_display);

					if (apiMessage.toLowerCase().includes('duplicate key') || apiMessage.toLowerCase().includes('already exists')) {
						Message.error({ message: m0012[0].message_display });
					} else {
						Message.error({ message: apiMessage });
					}
				}
			} else {
				console.log('payload for details saving ==>', formValues, detailsData);
				console.log('🚀 ~ handleConfirm ~ drDeleteList being sent:', drDeleteList);
				//update invoice
				try {
					const updatePayload = {
						...formValues,
						// Invoice API currently derives last_updated_by from preparedBy.
						// Force current session user during update/edit flows.
						preparedBy: loggedinUser.userName,
					};
					const updateRes = await updateInvoiceAPI(updatePayload, detailsData);
					
					if (updateRes.data.invoice_id !== undefined) {
							if (formValues.submit_val === 'post') {
								Message.success({ message: m0005[0].message_display });

								const handlePush = await handPushResult();
								navigate.push({
									pathname: '/invoice/details_update',
									state: {
										record: handlePush,
									},
								});
								setTimeout(() => {
									window.location.reload(false);
								}, 500); // 0.5 second delay
							} else if (formValues.submit_val === 'cancel') {
								Message.success({ message: m0010[0].message_display });

								const handlePush = await handPushResult();
								navigate.push({
									pathname: '/invoice/details_update',
									state: {
										record: handlePush,
									},
								});
								setTimeout(() => {
									window.location.reload(false);
								}, 500); // 0.5 second delay
							} else {
								Message.success({ message: m0006[0].message_display });

								const handlePush = await handPushResult();
								navigate.push({
									pathname: '/invoice/details_update',
									state: {
										record: handlePush,
									},
								});
								setTimeout(() => {
									window.location.reload(false);
								}, 500); // 0.5 second delay
							}

							if (deleteList.length > 0) {
								const lineIdValue = deleteList.reduce(
									(result, item) =>
										result ? `${result} ,${item.invoice_line_id}` : `${item.invoice_line_id}`,
									'',
								);
								const delDetails = await deleteInvDetailsAPI(lineIdValue);
							}
						} else {
							const res = updateRes;
							Message.error({ message: m0007[0].message_display });
						}
				} 
				catch (error) {
					console.log('updateRes error', error);
					const apiMessage = getApiErrorMessage(error, m0007[0].message_display);

					if (apiMessage.toLowerCase().includes('duplicate key') || apiMessage.toLowerCase().includes('already exists')) {
						Message.error({ message: m0012[0].message_display });
					} else {
						Message.error({ message: apiMessage });
					}
				}
			}
		} else {
			Message.error({ message: m0014[0].message_display });
		}
	}

	const showBackConfirmModal = () => {
		const m0008 = messagesList.filter(items => items.message_code === 'M0008');
		const title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
		const content =
			m0008[0].message_display === undefined
				? 'Changes will be cancelled'
				: m0008[0].message_display;

		Modal.confirm({
			title,
			content,
			icon: <ExclamationCircleOutlined />,
			okText: 'YES',
			cancelText: 'NO',
			onOk: () => {
				navigate.push(invoiceSearchLink);
			},
		});
	};

	const handleBack = () => {
		const getValues = form.getFieldValue();

		const checkBackVal = form.getFieldsValue(null, meta => meta.touched);
		const backArr = Object.values(checkBackVal);

		if (backArr.length > 0) {
			if (['POSTED', 'CANCELLED'].includes(getValues.status)) {
				if (editButtonClicked) {
					showBackConfirmModal();
				} else {
					navigate.push(invoiceSearchLink);
				}
			} else {
				showBackConfirmModal();
			}
		} else {
			navigate.push(invoiceSearchLink);
		}
	};

	const handleRefresh = async () => {
		if (props.isEditting) {
			const handlePush = await handPushResult();
			navigate.push({
				pathname: '/invoice/details_update',
				state: {
					record: handlePush,
				},
			});
			setTimeout(() => {
				window.location.reload(false);
			}, 500); // 0.5 second delay
		} else {
			setTimeout(() => {
				window.location.reload(false);
			}, 500); // 0.5 second delay
		}
	};

	const handlePrint = async value => {
		console.log('value prnt', value);
		
		// Set loading state based on action
		if (value === 'print') {
			setPrintLoading(true);
		} else if (value === 'preview') {
			setPrintPreviewLoading(true);
		}
		
		const getUser = usersList.filter(user => user.user_id === invDetProps.prepared_by);
		const m0015 = messagesList.filter(items => items.message_code === 'M0015');
		const getfieldValues = form.getFieldsValue();

		// Check if there's no data to print
		if (!detailsData || detailsData.length === 0) {
			Message.error({ message: 'Please add invoice details before printing. Save the invoice first.' });
			return;
		}

		let checkEdittedValues = false;

		if (props.isEditting) {
			// Additional safety check for editing mode
			if (!invDetails || invDetails.length === 0 || !detailsData || detailsData.length === 0) {
				Message.error({ message: 'Please save the invoice details before printing.' });
				return;
			}

			if (
				invDetails[0].line_description === detailsData[0].line_description &&
				parseFloat(invDetails[0].quantity) ===
					parseFloat(String(detailsData[0].quantity).replace(/,/g, '')) &&
				invDetails[0].unit_name === detailsData[0].unit_name &&
				parseFloat(invDetails[0].unit_price) ===
					parseFloat(String(detailsData[0].unit_price).replace(/,/g, '')) &&
				parseFloat(invDetails[0].line_amount) ===
					parseFloat(String(detailsData[0].line_amount).replace(/,/g, ''))
			) {
				checkEdittedValues = false;
			} else {
				checkEdittedValues = true;
			}
		}

		if (checkEdittedValues) {
			Message.error({ message: m0015[0].message_display });
		} else {
			if (getfieldValues.status === 'CANCELLED') {
				const m0015message =
					m0015[0].message_display === undefined
						? 'Transaction is Cancelled'
						: m0015[0].message_display;
				Message.error({ message: m0015message });
			} else {
				const sold_by = agentsList.filter(items => items.agent_id === invDetProps.agent_id);
				const sold_to = customersList.filter(
					items => items.customer_id === invDetProps.customer_id,
				);

				const report_details = detailsData.map(value => {
					return {
						invoice_no: getfieldValues.invoiceNumber,
						sold_to: sold_to[0].customer_name, //getfieldValues.soldTo,
						address: getfieldValues.address,
						invoice_date: moment(getfieldValues.invoiceDate).format('MMMM DD, YYYY'),
						term_name: getfieldValues.terms,
						tax_id_no: getfieldValues.taxNumber,
						business_style: getfieldValues.businessStyle,
						dr_no: invDetProps.dr_desc === null ? '' : invDetProps.dr_desc,
						po_no: getfieldValues.poNumber,
						vatable_sales: getfieldValues.vatableSales,
						vat_amount: getfieldValues.vatAmount,
						invoice_amount: getfieldValues.invoiceAmount,
						remarks: getfieldValues.remarks,
						remarks2: getfieldValues.remarks2,
						line_no: value.line_no,
						line_description: value.line_description,
						quantity: value.quantity,
						unit: value.unit_name,
						unit_price: value.unit_price,
						amount: value.line_amount,
						checked_by: getfieldValues.checkedBy.toUpperCase(),
						prepared_by: `${getUser[0].first_name} ${getUser[0].last_name}`.toUpperCase(),
						sold_by: sold_by[0].agent_name.toUpperCase(),
						totalAmountDue: getfieldValues.totalAmountDue,
						withholdTax: getfieldValues.withholdTax,
						addVat: getfieldValues.addVat,
						netOfVat: getfieldValues.netOfVat,
						lessVat: getfieldValues.lessVat,
						zeroRateSales: getfieldValues.zeroRateSales,
						cash_charge: getfieldValues.cash_charge
					};
				}); // -- end report details
				console.log('🚀 ~ handlePrint ~ report_details:', report_details);

				if (value === 'print') {
					try {
						//print data
						const data = {
							xml_name: 'PRT_INVOICE', //test_invoice_report
							type: 'pdf',
							report_name: loggedinUser.userName,
							report_details: report_details,
						}; // -- end data

						const handlePrint = await printInvoice(data);
						const pdf_file = handlePrint.records[0].pdf;
						if (pdf_file) {
							const trxnData = {
								trxn_type: 'invoice',
								trxn_no: getfieldValues.invoiceNumber,
								created_by: loggedinUser.userID,
							};
							const savePrintedTrxn = await invPrintedTrxnAPI(trxnData);
						}

						let pdfWindow = window.open();
						if (pdfWindow !== null || pdfWindow !== undefined) {
							pdfWindow.document.write(
								"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
									encodeURI(pdf_file) +
									"'></iframe>",
							);

							// setTimeout(() => {
							// 	window.location.reload();
							// }, 500); // 0.5 second delay
						} else {
							Message.error({ message: 'The action did not continue. Please try again.' });
						}
					} catch (error) {
						console.log('Print error:', error);
						Message.error({ message: 'Print failed. Please try again.' });
					} finally {
						setPrintLoading(false);
					}
				} else if (value === 'preview') {
					try {
						console.log('preview');
						const data = {
							xml_name: 'PRT_INVOICE',
							type: 'pdf',
							report_name: loggedinUser.userName,
							report_details: report_details,
						}; // -- end data

						const handlePrint = await printInvoicePreview(data);
						const pdf_file = handlePrint.records[0].pdf;

						let pdfWindow = window.open();
						if (pdfWindow !== null || pdfWindow !== undefined) {
							pdfWindow.document.write(
								"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
									encodeURI(pdf_file) +
									"'></iframe>",
							);

							setTimeout(() => {
								window.location.reload();
							}, 500); // 0.5 second delay
						} else {
							Message.error({ message: 'The action did not continue. Please try again.' });
						}
					} catch (error) {
						console.log('Print preview error:', error);
						Message.error({ message: 'Print preview failed. Please try again.' });
					} finally {
						setPrintPreviewLoading(false);
					}
				} else {
					Message.info({ message: 'Action was not recognized.' });
				}
			}
		}
	};

	const disabledDate = current => {
		// Can not select future dates
		return current > moment().endOf('day');
	};

	const validateMessages = {
		required: 'Required Field',
	};

	const handleEditOnClick = e => {
		// setSoldToDisabled(false);
		// setAllDisabled(false);
		setEditButtonClicked(true);
	};

	return isloading ? (
		<div className="spin-loading">
			<Spin tip="Loading..." size="large"></Spin>
		</div>
	) : (
		<div>
			<Card>
				<PageTitle pageTitle="INVOICE" />
				<Form
					layout="vertical"
					validateMessages={validateMessages}
					onFinish={handleSubmit}
					onKeyDown={handleKeyDown}
					form={form}
				>
					<Row gutter={[8, 1]} justify="space-around" align="top">
						<Col span={3}>
							<Form.Item
								style={formItemStyle}
								name="invoiceNumber"
								label="INVOICE NO."
								rules={[{ required: true }]}
								initialValue={props.isEditting ? invDetProps.invoice_no : ''}
							>
								<AlphaNumInput
									disabled={props.isEditting ? true : false}
									className="inv-input-uppercase"
									placeholder="INVOICE NO."
									maxLength="50"
									onBlur={onBlurInvNum}
								/>
							</Form.Item>
							{/* <Button onClick={testTest}>Test Invoice</Button> */}
						</Col>
						<Col span={3}>
							<Form.Item
								style={formItemStyle}
								name="invoiceDate"
								label="INVOICE DATE"
								rules={[{ required: true }]}
								initialValue={
									props.isEditting
										? moment.utc(invDetProps.formated_inv_date, 'MM/DD/YYYY')
										: moment.utc()
								}
							>
								{/* @ts-ignore */}
								<DatePicker
									style={{ width: '100%' }}
									format="MM/DD/YYYY"
									value={value => moment.utc(value)}
									disabled={allDisabled}
									// disabled={editButtonClicked ? false : allDisabled}
									// disabledDate={disabledDate}
								/>
							</Form.Item>
						</Col>
						<Col span={6}>
							<Form.Item
								style={formItemStyle}
								name="agent"
								label="AGENT"
								rules={[{ required: true }]}
								initialValue={props.isEditting ? invDetProps.agent_id : []}
							>
								<Select
									disabled={allDisabled}
									placeholder="AGENT"
									showSearch
									filterOption={(input, option) =>
										(option.children || '').toLowerCase().includes(input.toLowerCase())
									}
								>
									{agentOptions}
								</Select>
							</Form.Item>
						</Col>
						<Col span={3}>
							<Form.Item
								style={formItemStyle}
								name="status"
								label="STATUS"
								initialValue={props.isEditting ? invDetProps.status_name : 'NEW'}
							>
								<Input disabled={true} />
							</Form.Item>
						</Col>
						<Col span={9}>
							<Form.Item
								style={formItemStyle}
								name="soldTo"
								label="SOLD TO"
								rules={[{ required: true }]}
								initialValue={props.isEditting ? invDetProps.customer_val : []}
							>
								<Select
									placeholder="CUSTOMER"
									showSearch
									filterOption={(input, option) =>
										option.value.toLowerCase().startsWith(input.toLowerCase())
									}
									onChange={handleSoldToOnChange}
									disabled={allDisabled}
								>
									{soldToOptions}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]} align="top">
						<Col span={8}>
							<Form.Item
								style={formItemStyle}
								name="businessStyle"
								label="BUSINESS STYLE"
								initialValue={props.isEditting ? invDetProps.business_style : ''}
							>
								<AutoComplete
									disabled={soldToDisabled}
									placeholder="BUSINESS STYLE"
									style={{ width: '100%' }}
									onSelect={handleBSOnSelect}
								>
									{busStyleOptions}
								</AutoComplete>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="vatInput"
								label="VAT INPUT"
								rules={[{ required: true }]}
								initialValue={props.isEditting ? invDetProps.vat_input_name : []}
							>
								<Select
									placeholder="VAT INPUT"
									disabled={soldToDisabled}
									showSearch
									filterOption={(input, option) =>
										option.children.toLowerCase().includes(input.toLowerCase())
									}
									onChange={handleVatInputOnChange}
								>
									{vatInputOptions}
								</Select>
							</Form.Item>
						</Col>
						<Col span={5}>
							<Form.Item
								style={formItemStyle}
								name="taxNumber"
								label="TAX ID. NO."
								rules={[{ required: true }]}
								initialValue={props.isEditting ? invDetProps.tax_id_no : ''}
							>
								<AlphaNumInput
									className="inv-input-uppercase"
									placeholder="TAX ID. NO."
									disabled={soldToDisabled}
									onChange={tinValue}
								/>
							</Form.Item>
						</Col>
						<Col span={7}>
							<Form.Item
								style={formItemStyle}
								name="terms"
								label="TERMS"
								rules={[{ required: true }]}
								initialValue={props.isEditting ? invDetProps.term_name : []}
							>
								<Select
									placeholder="TERMS"
									disabled={soldToDisabled}
									showSearch
									filterOption={(input, option) =>
										option.children.toLowerCase().includes(input.toLowerCase())
									}
									onChange={handleTermsChange} // Handle change event
								>
									{termsOptions}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]} align="top">
						<Col span={12}>
							<Form.Item
								style={formItemStyle}
								name="address"
								label="BILLING ADDRESS"
								rules={[{ required: true }]}
								initialValue={props.isEditting ? invDetProps.address : ''}
							>
								<AutoComplete
									disabled={soldToDisabled}
									placeholder="BILLING ADDRESS"
									style={{ width: '100%' }}
									onSelect={handleAddOnSelect}
								>
									{addressOptions}
								</AutoComplete>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								style={formItemStyle}
								name="remarks"
								label="REMARKS"
								initialValue={props.isEditting ? invDetProps.remarks : ''}
							>
								<Input
									className="inv-input-uppercase"
									placeholder="REMARKS"
									disabled={allDisabled}
									maxLength={100}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]} justify="space-around">
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="poNumber"
								label="PO NO."
								initialValue={props.isEditting ? invDetProps.po_no : ''}
							>
								<Input
									className="inv-input-uppercase"
									placeholder="PO NO."
									maxLength={50}
									disabled={allDisabled}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="checkedBy"
								label="CHECKED BY"
								initialValue={props.isEditting ? invDetProps.checked_by : ''}
							>
								<AlphaNumInput
									className="inv-input-uppercase"
									placeholder="CHECKED BY"
									disabled={allDisabled}
									maxLength={50}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="preparedBy"
								label="PREPARED BY"
								initialValue={
									props.isEditting ? invDetProps.prepared_by_username : loggedinUser.userName
								}
							>
								<Input
									className="inv-input-uppercase"
									placeholder="PREPARED BY"
									disabled
									maxLength={100}
								/>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								style={formItemStyle}
								name="remarks2"
								label="REMARKS 2"
								initialValue={props.isEditting ? invDetProps.remarks2 : ''}
							>
								<Input
									className="inv-input-uppercase"
									placeholder="REMARKS 2"
									disabled={allDisabled}
									maxLength={100}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]}>
						<Col span={0}>
							<Form.Item
								style={formItemStyle}
								name="drNumber"
								// label="DR NOs."
								initialValue={
									props.isEditting
										? invDetProps.dr_val === null
											? []
											: invDetProps.dr_val.split(',').map(n => parseInt(n, 10))
										: []
								}
							></Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="invStatus"
								label="INVOICE STATUS"
								initialValue={
									props.isEditting
										? invDetProps.invoice_type_name
										: invTypesList[0].invoice_type_name
								}
							>
								<Select
									placeholder="INVOICE STATUS"
									// onChange={handleInvStatus}
									disabled={allDisabled}
								>
									{invTypesOptions}
								</Select>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="ewtamt"
								label="EWT"
								rules={[{ required: true }]}
								initialValue={props.isEditting ? invDetProps.ewt_percentage : '0'}
							>
								<Select
									placeholder="EWT"
									disabled={soldToDisabled}
									// disabled={editButtonClicked === true ? false : soldToDisabled}
									onChange={ewtOnchange} // onChange event handler for the select input
								>
									<Select.Option value="0">0%</Select.Option>
									<Select.Option value="0.01">1%</Select.Option>
									<Select.Option value="0.02">2%</Select.Option>
								</Select>
							</Form.Item>
						</Col>
						<Col span={10}></Col>
						<Col span={6}>
							<Form.Item name="cash_charge">
								<Radio.Group
									disabled={soldToDisabled}
									style={{ paddingLeft: 15 }}
									value={cashChargeValue} // Set value of Radio.Group based on state
								>
									<Radio value="CASH SALES">CASH SALES</Radio>
									<Radio value="CHARGE SALES">CHARGE SALES</Radio>
								</Radio.Group>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="vatableSales"
								label="VATABLE SALES"
								initialValue="0.00"
							>
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item style={formItemStyle} name="vatAmount" label="VAT" initialValue="0.00">
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="zeroRateSales"
								label="ZERO RATED SALES"
								initialValue="0.00"
							>
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="vatExemptSales"
								label="VAT-EXEMPT SALES"
								initialValue="0.00"
							>
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={6}></Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="invoiceAmount"
								label="TOTAL SALES (VAT INCLUSIVE)"
								initialValue="0.00"
							>
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item style={formItemStyle} name="lessVat" label="LESS: VAT" initialValue="0.00">
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="netOfVat"
								label="AMOUNT: NET OF VAT"
								initialValue="0.00"
							>
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item style={formItemStyle} name="addVat" label="ADD: VAT" initialValue="0.00">
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="withholdTax"
								label="LESS: WITHHOLDING TAX"
								initialValue={props.isEditting ? invDetProps.withholdTax : '0.00'}
							>
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item
								style={formItemStyle}
								name="totalAmountDue"
								label="TOTAL AMOUNT DUE"
								initialValue="0.00"
							>
								<Input placeholder="0.00" disabled />
							</Form.Item>
						</Col>
					</Row>
					<InvoiceTable
						form={form}
						invDetails={invDetails}
						handleTotVal={handleTotVal}
						handleTableData={handleTableData}
						handleDrList={handleDrList}
						disabled={allDisabled}
						soldToDisabled={soldToDisabled}
						messagesList={messagesList}
						unitList={unitList}
						drList={filterDrNoList}
						handleDeleteList={handleDeleteList}
						tblLoading={tblLoading}
						isEditting={props.isEditting}
						editButtonClicked={editButtonClicked}
						invDetProps={invDetProps}
						selectedDrIdList={selectedDrIdList}
						handleSelectedDrIdList={handleSelectedDrIdList}
						customerName={form.getFieldValue('soldTo')}
						previousSoldToValue={previousSoldToValue}
						selectedDrValues={(props.isEditting)
									? invDetProps.dr_val === null ? [] : invDetProps.dr_val.split(',').map( n => parseInt(n, 10))
									: []
								}
					/>
					<Row gutter={[8, 1]} justify="space-around">
						<Col className="button-below" span={12}>
							{/* {(props.isEditting && invDetProps.status_name === 'POSTED') && (printInvoiceRight === 'TRUE') ? */}
							{(props.isEditting && invDetProps.status_name === 'POSTED') && (printInvoiceRight === 'TRUE') ? 
                                (
                                    <Button
                                        className="inv-button"
                                        type="primary"
                                        icon={<PrinterOutlined />}
                                        disabled={(props.isEditing ? printPrintButtonDisabled : false) || (detailsData.length === 0) || printLoading}
                                        loading={printLoading}
                                        onClick={() => handlePrint('print')}
                                    >
                                        PRINT
                                    </Button>
							    ) : (
								<></>
							)}
							{props.isEditting &&
							invDetProps.status_name !== 'CANCELLED' &&
							printInvoiceRight === 'TRUE' ? (
								<Button
									className="inv-button"
									type="primary"
									icon={<PrinterOutlined />}
									disabled={(props.isEditing ? printPrintButtonDisabled : false) || (detailsData.length === 0) || printPreviewLoading}
									loading={printPreviewLoading}
									onClick={() => handlePrint('preview')}
								>
									PRINT PREVIEW
								</Button>
							) : (
								<></>
							)}
							<Button
								className="inv-button"
								type="primary"
								icon={<SyncOutlined />}
								disabled={
									props.isEditting && invDetProps.status_name === 'CANCELLED' ? allDisabled : false
								}
								onClick={handleRefresh}
							>
								REFRESH
							</Button>
						</Col>
						<Col className="button-below" span={12}>
							<Form.Item name="submit_val">
								<div style={footerStyleRight}>
									<Button
										className="inv-button"
										type="primary"
										icon={<RollbackOutlined />}
										onClick={handleBack}
									>
										BACK
									</Button>
									{props.isEditting && cancelInvoiceRight === 'TRUE' ? (
										<Button
											className="inv-button"
											type="primary"
											icon={<StopOutlined />}
											htmlType="submit"
											onClick={() => {
												form.setFieldsValue({ submit_val: 'cancel' });
												setCheckPost(true);
											}}
											disabled={invDetProps.status_name === 'CANCELLED' ? allDisabled : false}
										>
											CANCEL INVOICE
										</Button>
									) : (
										<></>
									)}

									{props.isEditting &&
									invDetProps.status_name === 'POSTED' &&
									overrideInvoiceRight === 'TRUE' ? (
										<Button
											type="primary"
											onClick={handleEditOnClick}
											disabled={editButtonDisabled}
										>
											EDIT
										</Button>
									) : (
										<></>
									)}

									<Button
										className="inv-button"
										type="primary"
										htmlType="submit"
										icon={<SaveOutlined />}
										onClick={() => {
											form.setFieldsValue({ submit_val: 'save' });
											const getValues = form.getFieldValue();

											if (getValues.submit_val === 'save' && detailsData.length > 0) {
												const chLineDesc = detailsData.filter(
													item => item.line_description === '-',
												);
												const chLineAmt = detailsData.filter(item => item.line_amt === 0);

												if (chLineDesc.length > 0 || chLineAmt > 0) {
													setCheckPost(false);
												} else {
													setCheckPost(true);
												}
											} else {
												setCheckPost(true);
											}
										}}
										disabled={editButtonClicked ? false : allDisabled}
									>
										SAVE
									</Button>

									{postInvoiceRight === 'TRUE' ? (
										<Button
											className="inv-button"
											type="primary"
											htmlType="submit"
											icon={<SnippetsOutlined />}
											onClick={() => {
												form.setFieldsValue({ submit_val: 'post' });
												const getValues = form.getFieldValue();

												const chLineDesc = detailsData.filter(
													item => item.line_description === '-',
												);
												const chLineAmt = detailsData.filter(item => item.line_amt === 0);

												if (getValues.submit_val === 'post' && detailsData.length === 0) {
													setCheckPost(false);
												} else if (getValues.submit_val === 'post' && detailsData.length > 0) {
													if (
														getValues.invoiceAmount === '0.00' ||
														getValues.invoiceAmount === '0'
													) {
														setCheckPost(false);
													} else if (chLineDesc.length > 0 || chLineAmt > 0) {
														setCheckPost(false);
													} else {
														setCheckPost(true);
													}
												} else {
													setCheckPost(true);
												}
											}}
											disabled={allDisabled}
										>
											POST
										</Button>
									) : (
										<></>
									)}
								</div>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Card>
		</div>
	);
}
